module.exports = __webpack_public_path__ + "static/img/84093E_1_2_C_20220509_fit.8159020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84093E_1_2_C_20220509_fit.png
// module id = Zqqy
// module chunks = 0